import PrintMultipleSlides from '../components/slides/PrintMultipleSlides.vue'
import FdlEmbed from '@/components/fdl/v1/FdlEmbed.vue'
import PrintAppointmentMemorialGuide from '@/components/home/PrintAppointmentMemorialGuide.vue'
import ComponentsView from '@/views/ComponentsView.vue'
import FuneralHomeGroupMedia from '@/views/FuneralHomeGroupMedia.vue'
import HomeView from '@/views/HomeView.vue'
import NewSession from '@/views/NewSession/NewSession.vue'
import PrintView from '@/views/PrintView.vue'
import SbPresentation from '@/views/SbPresentation.vue'
import SelectionCardsView from '@/views/SelectionCardsView.vue'
import SessionPresentation from '@/views/Session/SessionPresentation.vue'
import SessionDocument from '@/views/SessionDocument.vue'
import SessionView from '@/views/SessionView.vue'
import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: '/',
			name: 'home',
			component: HomeView,
		},
		{
			path: '/new-session',
			name: 'newSession',
			component: NewSession,
			props: (route) => ({ ...route.query, ...route.params }),
		},
		{
			path: '/session/:sessionId',
			props: true,
			component: SessionView,
			children: [
				{
					path: 'present',
					name: 'present',
					component: SessionPresentation,
					props: true,
				},
				{
					path: 'embed-present',
					name: 'embed-present',
					component: SessionPresentation,
					props: true,
					meta: {
						embedded: true,
					},
				},
				{
					path: 'documents',
					name: 'documents',
					component: SessionDocument,
					props: true,
				},
			],
		},
		{
			path: '/fdl/embed/v1/',
			props: true,
			name: 'fdl-embed-v1',
			component: FdlEmbed,
			meta: {
				embedded: true,
			},
		},
		// Views for Storyblok visual editor. URL matches path in Storyblok.
		{
			path: '/presentations/:presentationId(.+)',
			props: true,
			name: 'chapter-preview-default',
			component: SbPresentation,
		},
		{
			path: '/:lang/presentations/:presentationId(.+)',
			props: true,
			name: 'chapter-preview',
			component: SbPresentation,
		},
		// Views for Storyblok visual editor for Funeral Home Group Media.
		{
			path: '/funeral-home-info/:v4FhGroupId',
			props: true,
			name: 'funeral-home-group-media-default',
			component: FuneralHomeGroupMedia,
		},
		// Test page for viewing various components
		{
			path: '/components',
			name: 'components',
			component: ComponentsView,
		},
		// Test page for viewing different kinds of selection cards
		{
			path: '/selection-cards',
			name: 'selection-cards',
			component: SelectionCardsView,
		},
		// Page to print memorial guide, review slide, and payment options slide
		{
			path: '/session/:sessionId/print',
			name: 'print-multiple-slides',
			component: PrintMultipleSlides,
		},
		{
			path: '/print-mem-guide/appointment/:appointmentId',
			name: 'print-appointment-mem-guide',
			component: PrintAppointmentMemorialGuide,
		},
		{
			path: '/print-mem-guide/session/:sessionId',
			name: 'print-session-mem-guide',
			component: PrintAppointmentMemorialGuide,
		},
		{
			path: '/print',
			name: 'print',
			component: PrintView,
		},
	],
})

export default router
